var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3327 9.33301L17.3447 16.969C16.9379 17.2053 16.4758 17.3297 16.0053 17.3297C15.5349 17.3297 15.0728 17.2053 14.666 16.969L2.66602 9.33301",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.666 5.33301H5.33268C3.85992 5.33301 2.66602 6.52692 2.66602 7.99967V23.9997C2.66602 25.4724 3.85992 26.6663 5.33268 26.6663H26.666C28.1388 26.6663 29.3327 25.4724 29.3327 23.9997V7.99967C29.3327 6.52692 28.1388 5.33301 26.666 5.33301Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.bf13604e43d011f5bf5dfc8e909fa9fc.svg";
export { ForwardRef as ReactComponent };